import { z } from "zod";
import { getIdSchema, ID, makeIdGenerator } from "../utils";
import { hiveIdSchema } from "./hiveSchema";
import { scaleIdSchema } from "./scaleSchema";

export const scaleReportIdPrefix = "srp_";
export type ScaleReportId = ID<typeof scaleReportIdPrefix>;
export const generateScaleReportId = makeIdGenerator(scaleReportIdPrefix);
export const scaleReportIdSchema = getIdSchema(
  scaleReportIdPrefix,
  "ScaleReportId",
);

export const scaleReportSchema = z
  .object({
    id: scaleReportIdSchema,
    scaleId: scaleIdSchema,
    hiveId: hiveIdSchema.nullable(),
    time: z.coerce.date(),
    rawWeight: z.number(),
    weight: z.number().nullable(),
    boardTemperature: z.number(),
    battery: z.number(),
    signalStrength: z.number(),
    wifihivescaleId: z.number().nullable(),
    isManualSend: z.boolean(),
  })
  .meta({ id: "ScaleReport" });

export type ScaleReport = z.infer<typeof scaleReportSchema>;
